import React from "react";
import Home from "../views/Home";
import Calc from "../views/Calc";
import NotFound from "../views/NotFound";
import { Routes, Route } from "react-router-dom";

const AllRouter = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/calc" element={<Calc />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AllRouter;
